/** .gen file export modal — refreshes shade/production calcs then exports the design file. */
import React, {useState} from 'react';
import {Button, Flex} from "antd";
import {useViewerStore} from '../../../../../store/store';
import completedIcon from "../../../../../assets/img/icons/completed-icon.png";
import errorIcon from "../../../../../assets/img/icons/error-icon.png";
import {useExportCalculationPrep} from "../../../../../hooks/calculationStateHook";

const GenFilePopup = () => {

    const {sceneViewer} = useViewerStore(state => state);
    const [genFileGenerationStatus, setGenFileGenerationStatus] = useState('default');
    const { prepReady, blockedMessage, isBlocked } = useExportCalculationPrep();

    const confirmGenerateGenFile = async () => {
        setGenFileGenerationStatus('generating');
        const gen = await sceneViewer.exportJson();
        if(gen){
            setGenFileGenerationStatus('success');
        }
        else{
            setGenFileGenerationStatus('error');
        }
    }

    const cancel = () => {
        //Close Alert
        sceneViewer.viewerAlert({show: false});
    };

    return (
        <>
            {
                genFileGenerationStatus === 'success' ? (<Flex vertical justify={'center'} align={'center'}>                      
                    <p className="report-text">.GEN File Generated Successfully</p>
                    <img
                        src={completedIcon}
                        alt={"Completed Icon"}
                        width={50}
                        height={50}
                    />
                </Flex>) : genFileGenerationStatus === 'error' ? (<Flex vertical justify={'center'} align={'center'} gap={5}>
                    <p>.GEN File Generation Failed</p>
                    <img
                        src={errorIcon}
                        alt={"Error Icon"}
                        width={50}
                        height={50}
                    />
                    </Flex>) : genFileGenerationStatus === 'generating' ? (<Flex justify={'center'} align={'center'} gap={10}>
                        <span className="loader-icon-spinner"></span>
                        <p>Generating oneDRAW .GEN File</p>

                    </Flex>) : isBlocked ? (<Flex justify={'center'} align={'center'} gap={10}>
                        <span className="loader-icon-spinner"></span>
                        <p>{blockedMessage ?? 'Re-Calculating shades for all roofs…'}</p>

                    </Flex>) :

                    (<>
                        <p className="report-text">Click Confirm to Generate and Download oneDRAW .GEN File</p>

                        <div className={"modal-bottom-action-button-container"}>
                            <Button
                                id={"confirmSiteReportBtn"}
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-confirm-button"
                                disabled={!prepReady}
                                onClick={confirmGenerateGenFile}
                            >
                                Confirm
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-cancel-button"
                                onClick={cancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>)
            }
        </>
    )
}

export default GenFilePopup;